<template>
  <div class="export">
    <button @click="exportXLSX(question_result)">
      <DownloadFile />

      <span v-if="xlsxLoader"><Loader color="#696969"/></span>
    </button>

    <div class="text-hover">
      {{ parseTranslation(DOWNLOAD_TABLE) }}
    </div>
  </div>
</template>

<script>
import DownloadFile from '@/components/imgs/DownloadFile'

import Loader from '@/components/loading/Loader-3'

import * as translationDownloadChartButton from './downloadChartButtons.translations'

const { default: translations, ...translationKeys } = translationDownloadChartButton

export default {
  components: {
    DownloadFile,
    Loader,
  },

  props: {
    exportXLSX: {
      type: Function,
    },

    xlsxLoader: {
      type: Boolean,
      default: false,
    },

    question_result: {
      type: Object,
    },
  },

  data() {
    return {
      translations,
      ...translationKeys,
    }
  },
}
</script>

<style lang="scss" scoped>
.export {
  margin-right: 30px;
  position: relative;

  button {
    @include flexAlignCenter;
    background: $transparent;
    border: none;
    @include tipography(18);
    font-weight: bold;
    color: $gray-2;

    svg {
      height: 25px;
    }
  }

  &:hover {
    .text-hover {
      display: block;
    }
  }
}
</style>
